import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import bModal from 'bootstrap-vue/esm/components/modal/modal'
import bModalDirective from 'bootstrap-vue/esm/directives/modal/modal'
import ElementUI from 'element-ui'
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
import vueEventCalendar from 'vue-event-calendar'

import 'vue-event-calendar/dist/style.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/scss/app.scss'

Vue.use(BootstrapVue)
Vue.use(ElementUI)
Vue.use(require('vue-moment'))
Vue.use(require('moment/locale/es'))
locale.use(lang)

Vue.use(vueEventCalendar, {
  locale: 'es',
  color: '#373a3c', // Set main color
  className: 'dia-sel', // (default: 'selected-day')
  weekStartOn: 1
})

Vue.use(VueLodash, lodash)
Vue.component('b-modal', bModal)
Vue.directive('b-modal', bModalDirective)

Vue.config.productionTip = false
Vue.config.silent = true

/* eslint-disable no-new */
// eslint-disable-next-line
var vm = new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router,
  template: '<App/>',
  components: { App }
})
